import { useEffect, useState } from 'react';
import { minutesIntoReadableFormat } from '../../../Utils/Utils';
import { useRemote } from '../../../Utils/Utils';
import { format, sub } from 'date-fns';
import AnalyticsHeader from './AnalyticsHeader'
import Table from '../../../components/Table/Table';


const TopAssetClass = ({ dateRanges, type, ticker }) => {
    const remote = useRemote();
    const [data, setData] = useState([])
    const [tickersDateRange, setTickersDateRange] = useState(dateRanges[0]);

    const end = format(new Date(), 'yyyy-MM-dd')

    useEffect(() => {
        let time = { months: 6 }
        if (tickersDateRange) time = tickersDateRange
        let date = typeof tickersDateRange === "string" ? tickersDateRange : format(sub(new Date(), time), "yyyy-MM-dd")

        remote.get(`/analytics/aggregates/fund/${ticker}/asset-classes/rankings/${type}?from=${date}&to=${end}`).then(rankings => {
			setData(rankings)
		})

    }, [tickersDateRange]);

    return <>
        <div className='db-table-header'>
            <AnalyticsHeader dateRanges={dateRanges} timeFrame={tickersDateRange} setTimeFrame={setTickersDateRange}>{`Asset Class ${type === 'views' ? 'Views' : 'View Duration'}`}</AnalyticsHeader>
        </div>
        <AssetClassTable data={data} type={type} />
    </>
}

const AssetClassTable = ({ data, type }) => {
    const colWidths = ["90%", "150px"]

    const dataMap = () => data && data.map((assetClass, idx) => {
        const { name, count, minutes} = assetClass
        const duration =  minutes > 0 ? Math.ceil(minutes / count) : 0
        const formattedDuration =  minutesIntoReadableFormat(duration)
        return (
            <tr key={idx} className="cursor-pointer">
                <td>{name}</td>
                <td className="table-action-icons transition-fade-in-slow">{type === 'views' ? count : formattedDuration}</td>
            </tr>
        );
    });

    return <Table suggestionMessage rowSize="s" colWidths={colWidths} dataMap={dataMap()} />

}

export default TopAssetClass;